/**
 * Punto de entrada del frontend.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Aplicacion } from './Aplicacion';
import { retirarCabecerasDeRespaldo } from './seo/respaldo';
import './estilos/global.css';

retirarCabecerasDeRespaldo();

const raiz = document.getElementById('raiz');

if (raiz === null) {
  throw new Error('No se encontro el elemento #raiz en index.html');
}

createRoot(raiz).render(
  <StrictMode>
    <Aplicacion />
  </StrictMode>,
);
